module.exports = __webpack_public_path__ + "media/application/images/ui/logo-maori-56f229fcfc7f546ec9be2e8dd59c5fdf.png";